import { IScriptData } from "./script.types";
import { APIService } from "../../services/api-service";

export const getAll = () => {
  const url = "api/v1/script";
  return APIService.get<IScriptData>(url);
};
